import { Heart } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { usePostLikes } from '@/features/social/hooks/usePostLikes';
import { cn } from '@/lib/utils';
import LikeIcon from '@/assets/icons/like.svg';
import LikeOutlineIcon from '@/assets/icons/like_outline.svg';

interface LikeButtonProps {
  postId: string;
  className?: string;
}

export function LikeButton({ postId, className }: LikeButtonProps) {
  const { isLiked, likeCount, loading, toggleLike, canLike } = usePostLikes(postId);

  return (
    <div className="flex items-center space-x-2">
      <Button
        variant="ghost"
        size="sm"
        onClick={toggleLike}
        disabled={loading || !canLike}
        className={cn(
          "h-8 w-8 p-0 hover:bg-red-50/10",
          isLiked && "text-sossiety-red-600 hover:text-sossiety-red-500",
          !isLiked && "text-gray-200 hover:text-sossiety-red-600",
          className
        )}
      >
        {isLiked ? (
          <img src={LikeIcon} width={20} height={20} alt="Like" />
        ) : (
          <img src={LikeOutlineIcon} width={20} height={20} alt="Like outline" />
        )}
      </Button>
      {likeCount > 0 && (
        <span className="!ml-0 font-medium text-gray-200">
          {likeCount}
        </span>
      )}
    </div>
  );
} 